// Auto-generated file - DO NOT EDIT
// Generated at build time with API key from environment variables

export const ENV = {
  VITE_API_KEY: 'AIzaSyApWJzH3X_q0c2dOF6WNnGFqUpLaZx5bvg',
};

// Also expose to window for runtime access
if (typeof window !== 'undefined') {
  const win = window as any;
  if (!win.__VITE_API_KEY__) {
    win.__VITE_API_KEY__ = 'AIzaSyApWJzH3X_q0c2dOF6WNnGFqUpLaZx5bvg';
  }
}
